import { render } from "./vendor.vue?vue&type=template&id=29e79206&scoped=true"
import script from "./vendor.vue?vue&type=script&lang=js"
export * from "./vendor.vue?vue&type=script&lang=js"

import "./vendor.vue?vue&type=style&index=0&id=29e79206&lang=scss&scoped=true"

import exportComponent from "D:\\Cater-Frontend\\cater\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29e79206"]])

export default __exports__